// assets/es-geo-popup.js
// Custom replacement for Transtore's stock geo-location popup -- see the writeup in
// snippets/es-geo-popup.liquid for the full "why". Summary: auto-show a custom, on-brand popup
// only for visitors who are NOT in the US, once, then remember that choice for 90 days --
// Transtore's own popup was re-showing on every single hard page load regardless of prior choice,
// which is what this replaces. US visitors (or anyone we can't positively identify as
// international) get zero auto popup, but can still open the same picker manually any time via
// the globe icon in the header, or the "[Country] (Currency)" link in the footer (any element
// with data-es-geo-trigger).
//
// Presentation modes (2026-08-04, Jeff): the header icon opens a lightweight dropdown panel
// anchored under it on desktop (matching the wishlist/cart dropdown pattern he asked for) instead
// of the heavier centered modal -- click-triggered rather than pure CSS :hover like those,
// because this panel contains real interactive <select> fields and a submit button, and a
// hover-to-open/mouseleave-to-close panel is unreliable once the visitor's cursor has to travel
// into the panel to actually use a dropdown (a stray mouseout mid-interaction closes it). Mobile
// (no room to anchor a dropdown sensibly) and the footer link both keep the full centered modal,
// same as the auto-international popup.
(function () {
  var DISMISS_COOKIE = 'es_geo_dismissed';
  var DISMISS_DAYS = 90;
  var DROPDOWN_MIN_WIDTH = 768;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  }

  // Always suppress Transtore's own stock modal -- we render our own instead. Unconditional so
  // there's no flash of their modal before our JS finishes deciding anything.
  var hideStockModal = document.createElement('style');
  hideStockModal.textContent = '.ts-geo-modal { display: none !important; }';
  document.head.appendChild(hideStockModal);

  var popup = document.getElementById('es-geo-popup');
  if (!popup) return;

  var dialog = popup.querySelector('.es-geo-popup__dialog');

  function getCachedIpCountry() {
    try {
      var raw = localStorage.getItem('ts_ip');
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return (parsed && parsed.value && parsed.value.country) || null;
    } catch (e) {
      return null;
    }
  }

  // ?geo_test=intl on any URL forces the popup open regardless of detected country or the
  // dismiss cookie -- lets Jeff preview the international popup from a US browser without a VPN.
  // Not a persistent setting, just a one-time query param for that page load.
  var forceShowForTest = /[?&]geo_test=intl\b/.test(location.search);

  function isInternational() {
    if (forceShowForTest) return true;
    var liquidCountry = popup.getAttribute('data-current-country');
    var ipCountry = getCachedIpCountry();
    if (liquidCountry && liquidCountry !== 'US') return true;
    if (ipCountry && ipCountry !== 'US') return true;
    return false;
  }

  function onOutsideClick(e) {
    if (!dialog.contains(e.target)) dismiss();
  }

  function show() {
    popup.classList.add('es-geo-popup--visible');
    document.body.classList.add('es-geo-popup-open');
  }

  function showAsDropdown(trigger) {
    popup.classList.add('es-geo-popup--visible', 'es-geo-popup--dropdown-mode');
    var rect = trigger.getBoundingClientRect();
    var dialogWidth = 340;
    var left = Math.min(rect.left, window.innerWidth - dialogWidth - 16);
    left = Math.max(left, 16);
    dialog.style.top = (rect.bottom + 10) + 'px';
    dialog.style.left = left + 'px';
    // Deferred so the click that opened this doesn't immediately trigger onOutsideClick.
    setTimeout(function () {
      document.addEventListener('click', onOutsideClick);
    }, 0);
  }

  function dismiss() {
    popup.classList.remove('es-geo-popup--visible', 'es-geo-popup--dropdown-mode');
    document.body.classList.remove('es-geo-popup-open');
    dialog.style.top = '';
    dialog.style.left = '';
    document.removeEventListener('click', onOutsideClick);
    setCookie(DISMISS_COOKIE, '1', DISMISS_DAYS);
  }

  // Auto-show only if nothing has dismissed it in the last 90 days. This does NOT gate the
  // manual triggers below -- a visitor who dismissed the auto-popup (or is US and never saw it)
  // can still intentionally open the picker from the header/footer whenever they want.
  if (forceShowForTest || (!getCookie(DISMISS_COOKIE) && isInternational())) {
    setTimeout(function () {
      show();
    }, 700);
  }

  var closeBtn = popup.querySelector('.es-geo-popup__close');
  if (closeBtn) closeBtn.addEventListener('click', dismiss);

  var stayBtn = popup.querySelector('.es-geo-popup__stay-us');
  if (stayBtn) stayBtn.addEventListener('click', dismiss);

  var backdrop = popup.querySelector('.es-geo-popup__backdrop');
  if (backdrop) backdrop.addEventListener('click', dismiss);

  var form = document.getElementById('es-geo-popup-form');
  if (form) {
    // Real Shopify localization form submit -- a genuine page reload is correct/expected here
    // (every price on the page needs to re-render server-side in the new currency), unlike the
    // ShipInsure toggle bug. Set the dismiss cookie just before it navigates away so the popup
    // doesn't show again on the reloaded page.
    form.addEventListener('submit', function () {
      setCookie(DISMISS_COOKIE, '1', DISMISS_DAYS);
    });
  }

  // Header icon: dropdown on desktop, full modal on mobile (matches Jeff's ask -- keep mobile
  // as-is, dropdown-style only where there's room to anchor one sensibly).
  var headerTrigger = document.querySelector('.es-icon-btn[data-es-geo-trigger]');
  if (headerTrigger) {
    headerTrigger.addEventListener('click', function () {
      if (window.innerWidth >= DROPDOWN_MIN_WIDTH) {
        showAsDropdown(headerTrigger);
      } else {
        show();
      }
    });
  }

  // Every other manual trigger (footer link, any future one) always opens the full centered
  // modal -- simplest, and a bottom-of-page footer link has nowhere sensible to anchor a dropdown.
  document.querySelectorAll('[data-es-geo-trigger]').forEach(function (trigger) {
    if (trigger === headerTrigger) return;
    trigger.addEventListener('click', show);
  });
})();
